import { authFetch } from "@/lib/api-client";
import type { ScriptReviewCommentType } from "@/features/script-review/api/script-review.api";

// Prompt-improvement tickets (Adge-admin only): AI comments deleted with a
// reason, each carrying a worker-drafted suggestion for the global prompt.

export type ScriptReviewRejectionStatus =
  | "PENDING"
  | "READY"
  | "NOT_APPLICABLE"
  | "FAILED"
  | "APPROVED"
  | "IGNORED";

export interface ScriptReviewRejection {
  id: string;
  reviewId: string;
  reviewVersion: number;
  commentType: ScriptReviewCommentType;
  commentText: string;
  exactSecond: number;
  sceneNumber: number | null;
  severity: string | null;
  reason: string;
  rejectedAt: string;
  status: ScriptReviewRejectionStatus;
  promptKey: string;
  basePromptVersion: number | null;
  /** The prompt text the suggestion was drafted from — null when unresolvable. */
  basePromptContent: string | null;
  suggestedPrompt: string | null;
  suggestionRationale: string | null;
  suggestionError: string | null;
}

export async function listScriptReviewRejections(): Promise<{ items: ScriptReviewRejection[] }> {
  const { data } = await authFetch<{ items: ScriptReviewRejection[] }>(
    "/script-review-rejections",
  );
  return data;
}

export async function actionScriptReviewRejection(
  rejectionId: string,
  action: "approve" | "ignore",
): Promise<{ status: ScriptReviewRejectionStatus; appliedPromptVersion?: number }> {
  const { data } = await authFetch<{
    status: ScriptReviewRejectionStatus;
    appliedPromptVersion?: number;
  }>(`/script-review-rejections/${encodeURIComponent(rejectionId)}`, {
    method: "PATCH",
    body: JSON.stringify({ action }),
  });
  return data;
}
